// stores/driverScoreCalculate.js
'use client';

import { fleetApi } from '../api/axiosClient';

const getTzParam = () => `?tz=${Math.abs(new Date().getTimezoneOffset() / 60)}&useRetaseCalc=true`;

export const fetchDriverScoreCalculate = async (payload) => {
  try {
    const response = await fleetApi.post(`/driver-score-calculate${getTzParam()}`, payload);

    if (response?.data?.error === true || response?.data?.code >= 400 || response?.data?.code >= 403 || response?.data?.error) {
      throw { response: { data: response.data } };
    }

    const dataArr = response?.data?.data ?? response?.data ?? (Array.isArray(response) ? response : null);
    return dataArr;
  } catch (error) {
    console.error('Failed to fetch driver score calculate:', error?.response?.data ?? error);
    throw error;
  }
};
